import { render, staticRenderFns } from "./TitleDetailV1.vue?vue&type=template&id=5f9a723f&scoped=true"
import script from "./TitleDetailV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailV1.vue?vue&type=style&index=0&id=5f9a723f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a723f",
  null
  
)

export default component.exports